import { defineStore } from 'pinia';
import { useAuthStore } from './auth';

export const useThemeStore = defineStore({
  id: 'theme',

  state: () => ({
    isDark: false,
  }),

  getters: {
    // Check if user has PRO access (required for dark mode)
    canUseDarkMode: () => {
      const authStore = useAuthStore();
      const user = authStore.currentUser;

      // Allow dark mode if user is authenticated AND has an active subscription
      return user && user.subscription;
    },
  },

  actions: {
    toggleDarkMode() {
      // Check if user can use dark mode
      if (!this.canUseDarkMode && !this.isDark) {
        // Import router dynamically to avoid circular dependency
        import('@/router').then((router) => {
          router.default.push('/upgrade?from=v4_dark-mode');
        });
        return;
      }

      this.isDark = !this.isDark;
      // Save preference to localStorage
      localStorage.setItem('indiefy-theme', this.isDark ? 'dark' : 'light');
      // Update HTML and body classes for CSS selectors
      document.documentElement.classList.toggle('dark-theme', this.isDark);
      document.body.classList.toggle('body--dark', this.isDark);
    },

    setDarkMode(value) {
      // Only allow setting dark mode if user has PRO access
      if (value && !this.canUseDarkMode) {
        console.warn('Dark mode is a PRO feature');
        this.isDark = false;
        localStorage.setItem('indiefy-theme', 'light');
        document.documentElement.classList.remove('dark-theme');
        document.body.classList.remove('body--dark');
        return;
      }

      this.isDark = value;
      // Save preference to localStorage
      localStorage.setItem('indiefy-theme', this.isDark ? 'dark' : 'light');
      // Update HTML and body classes for CSS selectors
      document.documentElement.classList.toggle('dark-theme', this.isDark);
      document.body.classList.toggle('body--dark', this.isDark);
    },

    // Force light mode for non-PRO users
    enforceLightModeForBasicUsers() {
      if (!this.canUseDarkMode && this.isDark) {
        this.isDark = false;
        localStorage.setItem('indiefy-theme', 'light');
        document.documentElement.classList.remove('dark-theme');
        document.body.classList.remove('body--dark');
      }
    },
  },
});